import React from 'react';
export default Loading =>{
    return (
        <div className="loadingCss">Loading&#8230;</div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Common/Loading.js